import PromineoEditActionColumnButton from "components/common/PromineoEditActionColumnButton";
import PromineoDeleteActionColumnButton from "components/common/PromineoDeleteActionColumnButton";
import PromineoViewActionColumnButton from "components/common/PromineoViewActionColumnButton";


interface Props {
  onEditClick: () => void;
  onDeleteClick: () => void;
  onManageLicenseClick: () => void;
}

export default function ManageProductGridActions(props: Props) {
  const { onEditClick, onDeleteClick, onManageLicenseClick } = props;

  return (
    <>
      <div className="space-x-3">
        <PromineoEditActionColumnButton
          editClicked={onEditClick}
        />
        <PromineoDeleteActionColumnButton
          deleteClicked={onDeleteClick}
        />
        <PromineoViewActionColumnButton
          viewClicked={onManageLicenseClick}
        />
      </div>
    </>
  );
}

